(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mm-widged-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const widgedLists = document.querySelectorAll('.mm-widged-section .mm-widged-list');
    if (widgedLists.length > 4) {
      
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-padding-2-gift"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (window.quantityEventsAdded) return;
    window.quantityEventsAdded = true;

    const quantityContainers = document.querySelectorAll('.quantity-container');

    quantityContainers.forEach(container => {
      const minusBtn = container.querySelector('[data-quantity-minus]');
      const plusBtn = container.querySelector('[data-quantity-plus]');
      const quantityInput = container.querySelector('.quantity-input');

      if (minusBtn && plusBtn && quantityInput) {
        minusBtn.addEventListener('click', () => {
          let currentValue = parseInt(quantityInput.value);
          if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
          }
        });

        plusBtn.addEventListener('click', () => {
          let currentValue = parseInt(quantityInput.value);
          quantityInput.value = currentValue + 1;
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-padding-gift"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if (window.quantityEventsAdded) return;
    window.quantityEventsAdded = true;

    const quantityContainers = document.querySelectorAll('.quantity-container');

    quantityContainers.forEach(container => {
      const minusBtn = container.querySelector('[data-quantity-minus]');
      const plusBtn = container.querySelector('[data-quantity-plus]');
      const quantityInput = container.querySelector('.quantity-input');

      if (minusBtn && plusBtn && quantityInput) {
        minusBtn.addEventListener('click', () => {
          let currentValue = parseInt(quantityInput.value);
          if (currentValue > 1) {
            quantityInput.value = currentValue - 1;
          }
        });

        plusBtn.addEventListener('click', () => {
          let currentValue = parseInt(quantityInput.value);
          quantityInput.value = currentValue + 1;
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
